module.exports = __webpack_public_path__ + "img/1_013.e3c1e388.jpg";